<style lang="less" scoped>
  .editor-wrapper{
    max-width: 800px;
    margin: 0 auto;
  }
  .income-wrapper {
    border-top: 1px solid #dddee1;
    padding-top: 20px;
  }
  .add-btn{
    margin: 5px 0 20px 0;
  }
</style>
<template>
  <div>
    <Modal
      v-model="config.modal"
      :title="edit_title"
      fullscreen
      :loading="config.loading"
      ok-text="保存"
      @on-ok="editOk"
    >
      <Spin
        v-if="loading"
        fix
      />
      <Form
        v-show="!loading"
        ref="form"
        class="editor-wrapper"
        :model="edit_income_group"
        :label-width="110"
      >
        <Row>
          <i-col span="6">
            <FormItem label="编号">
              <span v-if="edit_income_group.uid">{{ edit_income_group.uid }}</span>
              <span
                v-else
                class="color-disabled"
              >自动生成</span>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem
              label="申请人"
              prop="apply_user"
              :rules="{ required: true, message: '申请人不能为空'}"
            >
              <CustomerSelector
                v-model="edit_income_group.apply_user_id"
                width="400"
                :disabled="!can_edit"
                @on-change="setApplyUser"
              >
                <span v-if="edit_income_group.apply_user">{{ edit_income_group.apply_user }}</span>
                <span
                  v-else
                  class="color-grey"
                >选择</span>
              </CustomerSelector>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="填制人">
              <span class="color-disabled">{{ edit_income_group.fill_user }}</span>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="填制时间">
              <span class="color-grey">{{ getFillTime(edit_income_group) }}</span>
            </FormItem>
          </i-col>
        </Row>
        <Row v-if="is_receipt">
          <i-col span="12">
            <FormItem
              label="收款类型"
              prop="bill_type"
              :rules="{ required: true, message: '收款类型不能为空'}"
            >
              <Select
                v-model="edit_income_group.bill_type"
                placeholder="收款类型"
              >
                <Option
                  v-for="bill_type in receipt_bill_types"
                  :key="bill_type.uid"
                  :value="bill_type.uid"
                >
                  {{ bill_type.name }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="12">
            <FormItem
              label="收款用途"
              prop="receipt_purpose_uid"
              :rules="{ required: true, message: '收款用途不能为空'}"
            >
              <Select
                v-model="edit_income_group.receipt_purpose_uid"
                not-found-text="请先选择[收款类型] 或 [收款类型]与[收款用途]未建立关联"
                placeholder="收款用途"
              >
                <Option
                  v-for="receipt_purpose in receipt_purposes"
                  v-show="receipt_purpose.bill_type_uid === edit_income_group.bill_type"
                  :key="receipt_purpose.kingdee_uid"
                  :value="receipt_purpose.kingdee_uid"
                >
                  {{ receipt_purpose.name }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
        </Row>
        <FormItem
          label="单据名称"
          prop="name"
          :rules="{ required: true, message: '名称不能为空'}"
        >
          <i-input
            v-model="edit_income_group.name"
            placeholder="xxx收款单/计提单"
          />
        </FormItem>
        <Row>
          <i-col span="12">
            <FormItem
              label="收款公司"
              prop="company_id"
              :rules="{type: 'number', required: true, min: 1, message: '请选择公司'}"
            >
              <Select
                v-model="edit_income_group.company_id"
                :disabled="edit_income_group.id > 0"
                placeholder="请输入收款公司"
                @on-change="companyChange"
              >
                <Option
                  v-for="company in companies"
                  :key="company.id"
                  :value="company.id"
                >
                  {{ company.name }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="12">
            <FormItem
              label="收款币别"
              prop="currency"
              :rules="{ required: true, message: '请选择币别' }"
            >
              <Select
                v-model="edit_income_group.currency"
                placeholder="请选择币别"
              >
                <Option
                  v-for="(currency, index) in currencies"
                  :key="index"
                  :value="currency.value"
                >
                  {{ currency.symbol }}-{{ currency.label }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
        </Row>
        <FormItem
          label="收款银行"
          prop="receipt_bank_id"
          :rules="{type: 'number', required: true, min: 1, message: '请选择公司'}"
        >
          <BankSelector
            v-model="edit_income_group.receipt_bank_id"
            :company_id="edit_income_group.company_id"
          />
        </FormItem>
        <Row>
          <i-col span="12">
            <FormItem
              label="付款单位类型"
              prop="unit_type"
              :rules="{ required: true, message: '请选择付款单位类型' }"
            >
              <Select
                v-model="edit_income_group.unit_type"
                placeholder="付款单位类型"
                @on-change="unitTypeChange"
              >
                <Option
                  v-for="unit_type in unit_types"
                  :key="unit_type.uid"
                  :value="unit_type.uid"
                >
                  {{ unit_type.name }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="12">
            <!-- 根据 unit_type 不同显示客户/员工/供应商-->
            <FormItem
              v-if="is_staff"
              label="员工"
              prop="staff_id"
              :rules="{type: 'number', required: true, min: 1, message: '请选择'}"
            >
              <CustomerSelector v-model="edit_income_group.staff_id" />
            </FormItem>
            <FormItem
              v-if="is_client"
              label="客户"
              prop="client_id"
              :rules="{type: 'number', required: true, min: 1, message: '请选择'}"
            >
              <Select
                v-model="edit_income_group.client_id"
                filterable
                clearable
              >
                <Option
                  v-for="client in clients"
                  :key="client.id"
                  :value="client.id"
                >
                  {{ client.name }}
                </Option>
              </Select>
            </FormItem>
            <FormItem
              v-if="is_supplier"
              label="供应商"
              prop="payee_company_id"
              :rules="{type: 'number', required: true, min: 1, message: '请选择'}"
            >
              <PayeeCompanySelector
                v-model="edit_income_group.payee_company_id"
              />
            </FormItem>
          </i-col>
        </Row>
        <Row>
          <i-col span="12">
            <FormItem
              label="对方账户名称"
              prop="opposite_account_name"
            >
              <i-input
                v-model="edit_income_group.opposite_account_name"
                placeholder="请输入..."
              />
            </FormItem>
          </i-col>
          <i-col span="12">
            <FormItem
              label="对方银行帐号"
              prop="opposite_bank_number"
            >
              <i-input
                v-model="edit_income_group.opposite_bank_number"
                placeholder="请输入..."
              />
            </FormItem>
          </i-col>
        </Row>
        <Row>
          <i-col span="12">
            <FormItem
              v-if="is_receipt"
              label="收款日期"
              prop="receipted_at"
              :rules="{ required: true, message: '收款日期不能为空' }"
            >
              <DatePicker
                :value="edit_income_group.receipted_at"
                placeholder="请选择"
                @on-change="receiptDateChange"
              />
            </FormItem>
          </i-col>
          <i-col span="12">
            <FormItem
              label="对方开户行"
              prop="opposite_bank_name"
            >
              <i-input
                v-model="edit_income_group.opposite_bank_name"
                placeholder="请输入..."
              />
            </FormItem>
          </i-col>
        </Row>
        <FormItem
          label="总金额"
        >
          <i-input
            :value="$util.formatPrice(total_price)"
            disabled
          />
        </FormItem>
        <FormItem
          label="单据备注"
        >
          <i-input
            v-model="edit_income_group.remark"
            type="textarea"
            placeholder="备注..."
          />
        </FormItem>

        <div
          v-for="(income, ii) in edit_income_group.incomes"
          :key="ii"
          class="income-wrapper"
        >
          <FormItem
            :label="`项目${ii + 1}`"
            :prop="`incomes.${ii}.name`"
            :rules="{required: true, message: '名称不能为空'}"
          >
            <i-input
              v-model="income.name"
              placeholder="项目名称"
            />
          </FormItem>
          <FormItem
            label="金额"
            :prop="`incomes.${ii}.price`"
            :rules="{required: true, validator: validatePrice}"
          >
            <i-input
              v-model="income.price"
              placeholder="金额"
            />
          </FormItem>
          <FormItem
            label="所属团队"
            :prop="`incomes.${ii}.team_id`"
            :rules="{type: 'number', required: true, min: 1, message: '请选择团队'}"
          >
            <Select
              v-model="income.team_id"
              placeholder="请选择"
            >
              <Option
                v-for="team in teams"
                :key="team.id"
                :value="team.id"
              >
                {{ team.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem
            label="科目"
            :prop="`incomes.${ii}.expense_type_id`"
            :rules="{type: 'number', required: true, min: 1, message: '请选择科目'}"
          >
            <ExpenseTypeSelector
              v-model="income.expense_type_id"
              :check_link_report="false"
            >
              <span v-if="income.expense_type_id">{{ getExpenseName(income.expense_type_id) }}</span>
              <span
                v-else
                class="color-grey"
              >选择</span>
            </ExpenseTypeSelector>
          </FormItem>
          <FormItem
            label="发票信息"
          >
            <IncomeInvoiceInfoEditor
              :income="income"
            />
          </FormItem>
          <FormItem
            label="备注"
          >
            <i-input
              v-model="income.remark"
              placeholder="备注..."
            />
          </FormItem>
          <Button
            v-if="ii > 0"
            icon="md-close"
            long
            @click="deleteIncome(income, ii)"
          >
            删除项目{{ ii+1 }}
          </Button>
          <Button
            v-if="isLastIncome(ii)"
            class="add-btn"
            type="primary"
            icon="md-add"
            long
            @click="addNewIncome"
          >
            添加项目
          </Button>
          <div
            v-if="ii > 0 && !isLastIncome(ii)"
            style="height: 20px;"
          />
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import IncomeUtil from '../libs/util';
  import { INCOME_GROUP, INCOME } from "../fields";
  import CustomerSelector from '../../components/customer/selector';
  import BankSelector from '../../expense_group/components/bank_selector';
  import PayeeCompanySelector from '../../payee_company/components/selector';
  import ExpenseTypeSelector from '../../expense_type/components/selector';
  import IncomeInvoiceInfoEditor from '../components/income_invoice_info_editor';
  import {mapGetters} from "vuex";
  import FlowUtil from "../../../libs/flow_util";
  import ExpenseUtil from "../../../libs/expense_util";

  export default {
    components: { CustomerSelector, BankSelector, ExpenseTypeSelector, PayeeCompanySelector, IncomeInvoiceInfoEditor },
    props: {
      type: {
        type: Number
      },
    },
    data() {
      return {
        loading: false,
        edit_income_group: INCOME_GROUP,
        config: {
          modal: false,
          loading: true,
        }
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      ...mapGetters({
        receipt_bill_types: 'async/receipt_bill_types',
        receipt_purposes: 'async/receipt_purposes',
        clients: 'async/clients',
        unit_types: 'async/unit_types',
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        expense_types: 'async/expense_types',
        expense_types_hash: 'async/expense_types_hash',
        banks_hash: 'async/banks_hash',
      }),
      currencies() {
        return ExpenseUtil.currencies;
      },
      currencies_hash() {
        return ExpenseUtil.currencies_hash;
      },
      is_receipt() {
        return this.edit_income_group.receipt_type === 0;
      },
      form_type() {
        return IncomeUtil.getReceiptType(this.edit_income_group.receipt_type);
      },
      edit_title() {
        return this.edit_income_group.id ? `编辑${this.form_type}单` : `添加${this.form_type}单`;
      },
      can_edit() {
        return FlowUtil.inEditNode(this.edit_income_group);
      },
      bank_info() {
        const bank = this.banks_hash[this.edit_income_group.receipt_bank_id];
        return bank ? `${bank.account}-${bank.bank_number}${bank.del ? '(已弃用)' : ''}` : '未知收款银行';
      },
      is_staff() {
        return this.edit_income_group.unit_type === 'BD_Empinfo';
      },
      is_client() {
        return this.edit_income_group.unit_type === 'BD_customer';
      },
      is_supplier() {
        return this.edit_income_group.unit_type === 'BD_Supplier';
      },
      total_price() {
        let total_price = 0;
        if (this.can_edit && this.edit_income_group.incomes) {
          this.edit_income_group.incomes.forEach((income) => {
            if (this.$util.isNumber(income.price)) {
              total_price = math.eval(`${income.price} + ${total_price}`).toFixed(2);
            }
          });
          return total_price;
        } else {
          return this.edit_income_group.total_price;
        }
      }
    },
    created() {
      window.ig = this;
    },
    mounted() {
      //
    },
    methods: {
      init() {
        if (typeof this.type === 'number') {
          this.edit_income_group.receipt_type = this.type;
        }
        if (this.cur_customer && this.cur_customer.id) {
          this.setFillUser(this.cur_customer);
          this.setApplyUser(this.cur_customer);
        }
      },
      edit(income_group) {
        this.config.modal = true;
        if (income_group) {
          if (income_group.id) {
            // 编辑
            this.loading = true;
            IncomeUtil.getDetail(income_group.id).then((data) => {
              this.$set(this, 'edit_income_group', data.income_group);
            }).catch(() => {
              this.$Message.error('获取数据失败, 请重试!');
              this.config.modal = false;
            }).finally(() => {
              this.loading = false;
            });
          } else {
            this.$set(this, 'edit_income_group', this.$util.clone(income_group));
          }
        } else {
          this.$set(this, 'edit_income_group', this.$util.clone(INCOME_GROUP));
          this.init();
        }
      },
      addNewIncome() {
        this.edit_income_group.incomes.push(this.$util.clone(INCOME));
      },
      companyChange(company_id) {
        const company = this.companies_hash[company_id];
        if (company && !this.edit_income_group.currency) {
          this.edit_income_group.currency = company.base_currency;
        }
      },
      unitTypeChange() {
        this.edit_income_group.client_id = 0;
        this.edit_income_group.payee_company_id = 0;
        this.edit_income_group.staff_id = 0;
      },
      receiptDateChange(date) {
        this.edit_income_group.receipted_at = date;
      },
      getFillTime(edit_income_group) {
        const time = edit_income_group.created_at || new Date();
        return this.$util.formatDate(time);
      },
      setFillUser(customer) {
        this.edit_income_group.fill_user_id = customer.id;
        this.edit_income_group.fill_user = customer.account;
      },
      setApplyUser(customer) {
        this.edit_income_group.apply_user_id = customer.id;
        this.edit_income_group.apply_user = customer.account;
      },
      getExpenseName(id) {
        const expense_type = this.expense_types_hash[id];
        return expense_type ? expense_type.full_name : '-';
      },
      validatePrice(rule, value, callback) {
        if (!this.$util.isNumber(value)) {
          callback(new Error('格式有误, 请输入正确的金额'));
        } else if (math.eval(`${value} == 0`)) {
          callback(new Error('金额不能为0'));
        } else {
          callback();
        }
      },
      editOk() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$util.ajax.post(this.$util.api.update_income_group, this.edit_income_group).then((response) => {
              return response.data;
            }).then((res) => {
              console.log(res);
              if (res.code === 1) {
                const income_group = res.data.income_group;
                this.$emit('update', income_group);
                this.config.modal = false;
                this.$Message.success('保存成功!');
              } else {
                this.$Modal.warning({title: '错误', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.warning({title: '错误', content: e.message});
            }).finally(() => {
              this.resetLoading();
            });
          } else {
            this.resetLoading();
          }
        });
      },
      resetLoading() {
        this.config.loading = false;
        setTimeout(() => {
          this.config.loading = true;
        }, 500);
      },
      isLastIncome(index) {
        return (index + 1) === this.edit_income_group.incomes.length
      },
      deleteIncome(income, index) {
        this.$Modal.confirm({
          title: '提示',
          content: '你确认要删除' + income.name + '吗?',
          onOk: () => {
            if (income.id) {
              this.$util.ajax.post(this.$util.api.delete_income, {
                id: income.id
              }).then((response) => {
                return response.data;
              }).then((res) => {
                if (res.code === 1) {
                  this.edit_income_group.incomes.splice(index, 1);
                  this.$Message.success('删除成功!');
                } else {
                  this.$Modal.error({title: '提示', content: res.msg});
                }
              }).catch(() => {
                this.$Modal.error({title: '提示', content: '删除失败'});
              });
            } else {
              this.edit_income_group.incomes.splice(index, 1);
            }
          }
        });
      },
    }
  }
</script>
